// S2-FE1: App root — routing + theme management
import { BrowserRouter, Routes, Route, useLocation } from 'react-router';
import { useEffect } from 'react';
import Landing from './pages/Landing';
import EvalDashboard from './pages/EvalDashboard';
import LLMControl from './pages/LLMControl';
import ComponentShowcase from './pages/ComponentShowcase';

// Theme controller: dark is the only theme (marketing + product) per design system.
// Light theme tokens retained in tokens.css for future doc/brand surfaces.
function ThemeProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
  }, [location.pathname]);

  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/eval" element={<EvalDashboard />} />
          <Route path="/llm" element={<LLMControl />} />
          <Route path="/eval/components" element={<ComponentShowcase />} />
          <Route path="/eval/*" element={<EvalDashboard />} />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>
  );
}
